<template>
  <v-container grid-list-md class="fb-post-create-process">
    <v-flex md12>
      <div class="card card-default">
        <div class="card-header">
          <h3 class="card-title">
            <i class="mdi mdi-heart-outline"></i>
            Buff Like , Sub Tây
          </h3>
        </div>
        <div class="card-body">
          <v-form ref="form_post_group_process">
            <v-layout row class="pa-0">
              <v-flex md2>
                <label class="text-color">Link hoặc ID </label>
              </v-flex>
              <v-flex md10>
                <v-text-field
                    solo
                    v-model="link"
                    required
                    hide-details="auto"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout align-center row>
              <v-flex md2><label class="text-color">Chọn loại cần buff </label></v-flex>
              <v-flex md10 class="mt-4">
                <v-radio-group v-model="type" row>
                  <v-radio label="Buff Sub (Theo dõi nick cá nhân)" :value="35" ></v-radio>
                  <v-radio label="Buff Like Fanpage (Theo dõi Page)" :value="36"></v-radio>
                  <v-radio label="Buff Like Post" :value="37"></v-radio>
                </v-radio-group>
              </v-flex>
            </v-layout>
            <v-layout align-center row class="pa-0 mb-4">
              <v-flex md2>
                <label class="text-color">Số lượng cần tăng</label>
              </v-flex>
              <v-flex md10>
                <v-text-field
                    solo
                    v-model="number"
                    type="number"
                    required
                    :rules="numberRule"
                    hide-details="auto"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout align-center row class="pa-0 mb-4">
              <v-flex md2>
                <label class="text-color">Giá tiền mỗi tương tác</label>
              </v-flex>
              <v-flex md10>
                <v-text-field
                    solo
                    v-model="price"
                    type="number"
                    required
                    :rules="priceRule"
                    hide-details="auto"
                ></v-text-field>
                <div class="text-danger mt-1">
                  <span class="red_text">Mẹo nhỏ : <span style="color: #1fab89">Hệ thống ưu tiên chạy các job giá cao trước nên nếu bạn cần gấp bạn có thể set giá job của mình cao hơn 1 vài đồng để chạy nhanh nhất có thể nhé.</span></span>
                </div>
              </v-flex>
            </v-layout>
            <v-layout row class="pa-0 mb-4">
              <v-flex md2>
                <label class="text-color">Ghi chú</label>
              </v-flex>
              <v-flex md10>
                <v-textarea
                    solo
                    v-model="content"
                    placeholder="Thêm ghi chú"
                    height="60px"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-form>
          <v-layout row class="pa-0 mb-4">
            <v-flex md12>
              <v-card style="background-color: #fff">
                <v-card-title>
                  <div class="div-total">
                    <h5>Tổng : <span class="font-weight-bold">
                      <span class="text-primary">{{totalCoin | currency_init}}</span>
                    </span>
                      <small>coin</small>
                    </h5>
                    <h6 class="mb-0">Giá tiến trình của bạn là <span class="text-primary">{{ price | currency_init }}</span>
                      <small>coin</small></h6>
                  </div>
                </v-card-title>
              </v-card>
            </v-flex>
          </v-layout>

          <v-layout row class="pa-0 mb-4">
            <v-flex md12>
              <v-btn width="100%" height="50px" style="background-color: #007bff"
                     class="white--text payment"
                     @click="saveProcess">
                <i class="mdi mdi-cart"></i>
                THANH TOÁN
              </v-btn>
            </v-flex>
          </v-layout>
        </div>
      </div>
    </v-flex>
    <v-overlay :value="overlay">
      <v-progress-circular
          indeterminate
          color="info"
      ></v-progress-circular>
    </v-overlay>
  </v-container>
</template>


<script>
    import { COLOR, SEEDING_TYPE } from "~/config/constant";
    import {
        SEEDING_TYPE_MAINTAIN,
        BUFF_TAY_SAVE_ORDER,
        BUFF_TAY_GET_PRICE
    } from "~/store/actions.type";
    import Swal from "sweetalert2";
    import {COMMON_SET_LOADING} from "../../store/mutations.type";
    export default {
        data() {
            return {
                COLOR: COLOR,
                images: [],
                maintain: false,
                content: '',
                overlay: true,
                number : 100,
                totalCoin : 0,
                price: 0,
                minPrice : 0,
                note: '',
                link: '',
                type : 35,
                numberRule : [
                    v => !!v || 'Trường này là bắt buộc',
                    v => v >= 100 || 'Ít nhất 100 share',
                ],
                priceRule : [
                    v => !!v || 'Trường này là bắt buộc',
                ],
            }
        },
        methods: {
            async getDataFromApi () {
                this.overlay = true
                let dataInfo = await this.$store.dispatch(SEEDING_TYPE_MAINTAIN);
                if (dataInfo.includes(SEEDING_TYPE.ID_SUB_TAY) || dataInfo.includes(SEEDING_TYPE.ID_LIKE_POST_TAY) || dataInfo.includes(SEEDING_TYPE.ID_LIKE_FANPAGE_TAY)) {
                    this.maintain = true;
                }
                this.overlay = false
            },
            async calculate () {
                this.totalCoin = this.price * this.number
            },
            validateForm () {
                let check = true
                let message = 'Thông tin điền đang chưa chính xác';
                if (!this.number || this.number < 100) {
                    check = false
                    message += '<br> Số lượng cần tăng không được thấp hơn 100'
                }
                if (!this.link) {
                    check = false
                    message += '<br> Link không thể để trống'
                }
                if (!this.price || this.price < this.minPrice) {
                    check = false
                    message += '<br> Giá tiền tối thiểu phải lớn hơn ' + this.minPrice + ' coin';
                }
                return { check: check, message: message }
            },
            async saveProcessApi () {
                this.$store.commit(COMMON_SET_LOADING, true)
                await this.$store.dispatch(BUFF_TAY_SAVE_ORDER, this.getParams())
                this.$store.commit(COMMON_SET_LOADING, false)
                this.content = ''
                this.images = []
            },
            getParams () {
                let formData = new FormData()
                formData.append('number', this.number)
                formData.append('content', this.content)
                formData.append('link', this.link)
                formData.append('price', this.price)
                formData.append('seeding_type', this.type)
                if (this.images.length) {
                    for (let file of this.images) {
                        formData.append('images[]', file)
                    }
                }
                return formData
            },
            async saveProcess() {
                this.calculate();
                let validateForm = this.validateForm();
                if (validateForm.check) {
                    try {
                        Swal.fire({
                            title: 'Xác nhận',
                            text: "Bạn có chắc chắn muốn tạo tiến trình ",
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'Đồng ý!',
                            cancelButtonText: 'Không'
                        }).then((result) => {
                            if (result.value) {
                                this.saveProcessApi();
                            }
                        })
                    } catch (error) {
                        console.log(error);
                    }
                } else {
                    Swal.fire(
                        validateForm.message,
                        '...',
                        'error'
                    )
                }
            },
            async getPrice () {
                this.overlay = true
                let res = await this.$store.dispatch(BUFF_TAY_GET_PRICE, {type : this.type});
                if (res.status) {
                    this.price = res.price
                    this.minPrice = res.price
                    this.calculate()
                }
                this.overlay = false
            },
        },
        watch: {
            number () {
                this.calculate()
            },
            price () {
                this.calculate()
            },
            type () {
                this.getPrice()
            }
        },
        mounted() {
            this.getDataFromApi();
        },
        created() {
            this.getPrice()
        }
    };
</script>
<style>
  .div-total {
    width: 100%;
    color: #000;
    text-align: center;
  }
  .div-total h5 {
    font-size: 1.2rem;
    margin-bottom: 0.5rem;
    font-family: inherit;
    font-weight: 400;
    line-height: 1.2;
    color: black;
  }
  .div-total h6 {
    font-family: inherit;
    font-weight: 400;
    line-height: 1.2;
    color: black;
    font-size: 0.9rem;
  }
  .div-total .font-weight-bold {
    font-weight: 700 !important;
  }
  .div-total .text-primary {
    color: #007bff !important;
  }
  .div-total .small, small {
    font-size: 80%;
    font-weight: 400;
  }
  .div-total .mb-0, .my-0 {
    margin-bottom: 0 !important;
  }
</style>
<style lang="scss">
  @import "../../scss/main";
  #vip-reaction-month {
    .text-color{
      color: $mainColor;
      font-weight: bold;
    }
    .v-tabs-slider-wrapper{
      color: $vip !important;
    }
    .text-color-vip{
      color: $vip;
      font-weight: bold;
    }
    .div-total {
      width: 100%;
      color: #000;
      text-align: center;
    }
    .div-total h5 {
      font-size: 1.2rem;
      margin-bottom: 0.5rem;
      font-family: inherit;
      font-weight: 400;
      line-height: 1.2;
      color: inherit;
    }
    .div-total h6 {
      font-family: inherit;
      font-weight: 400;
      line-height: 1.2;
      color: inherit;
      font-size: 0.9rem;
    }
    .div-total .font-weight-bold {
      font-weight: 700 !important;
    }
    .div-total .text-primary {
      color: #007bff !important;
    }
    .div-total .small, small {
      font-size: 80%;
      font-weight: 400;
    }
    .div-total .mb-0, .my-0 {
      margin-bottom: 0 !important;
    }
  }
</style>
